<template>
<span class="SelectDevice">
    <el-button class="SelectDeviceBtn" :type="btnType" @click="handleDialogShow" :plain="plain">
        <slot name='btnText'>{{btnText ? btnText : $t(/*选择设备*/'c.select_device')}}</slot>
    </el-button>
    <el-dialog class="SelectDeviceDialog" :title="btnText ? btnText : $t(/*选择设备*/'c.select_device')" width="640px" @close="handleDialogClose"
        :visible.sync="dialogShow" :modal-append-to-body="false" :append-to-body="true" :close-on-click-modal="false">
        <div class="title-container" style='padding: 0 12px;'>
            <el-row class="search-area">
                <!-- <el-col :span="12" class="search-item" v-if="!space">
                    <div class="key">{{$t(/*设备类型*/'device.device_space')}}：</div>
                    <div class="value">
                        <el-select v-model="searchForm.space" :placeholder="$t(/*请选择*/'c.select')" @change="pageChange(1)" clearable filterable>
                            <el-option v-for="item of spaceList" :label="$t(item.key)" :value="item.value" :key="item.value"/>
                        </el-select>
                    </div>
                </el-col> -->
                <el-col :span="12" class="search-item" v-if="$auth('ADMIN')">
                    <div class="key">{{$t(/*用户*/'c.user')}}：</div>
                    <div class="value">
                        <el-select v-model="searchForm.user_id" :placeholder="$t(/*请选择*/'c.select')" @change="pageChange(1)" clearable filterable>
                            <el-option v-for="item of userList" :label="item.username" :value="item.id" :key="item.id"/>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="12" class="search-item">
                    <div class="key">{{$t(/*设备UID*/'device.device_uid')}}：</div>
                    <div class="value">
                        <el-input v-model="searchForm.uid" :placeholder="$t(/*请输入*/'c.input')" @keydown.native.enter='pageChange(1)'/>
                    </div>
                </el-col>
                <el-col :span="24" class="search-item">
                    <div class="key">{{$t(/*在线状态*/'device.online_status')}}：</div>
                    <div class="value">
                        <el-radio-group v-model="searchForm.status" @change="pageChange(1)">
                            <el-radio-button v-for='(item,index) of statusList' :key='index' :label="item.value" >{{$t(item.key)}}</el-radio-button>
                        </el-radio-group>
                    </div>
                </el-col>
            </el-row>
            <div class="btn-area">
                <el-button type="primary" @click="pageChange(1)">{{$t(/*搜索*/'c.search')}}</el-button>
            </div>
        </div>
        <div class="table-container" style='padding-bottom: 20px;'>
            <el-table :data="tableData" @selection-change="handleSelectChange" v-loading="loading" >
                <el-table-column type="selection" width="44"></el-table-column>
                <el-table-column :label="$t(/*设备UID*/'device.device_uid')"  width="150">
                    <template slot-scope="{row}">{{ row.uid ? row.uid : '-' }}</template>
                </el-table-column>
                <el-table-column :label="$t(/*在线状态*/'device.online_status')" width="100">
                    <template slot-scope="{row}">
                        <div class="round-tag" :class="$U.deviceStatusFilter(row, 'class')">
                            {{$t($U.deviceStatusFilter(row))}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t(/*设备类型*/'device.device_space')">
                    <template slot-scope="{row}">{{$t($U.deviceSpaceFilter(row.space))}}</template>
                </el-table-column>
                <el-table-column :label="$t(/*最后活动时间*/'device.last_active_time')" width="190">
                    <template slot-scope="{row}">{{ $U.timeFormat(row.last_active_time) }}</template>
                </el-table-column>
            </el-table>
        </div>
        <div slot="footer" class="dialog-footer with-page">
            <el-pagination small
                @current-change="pageChange"
                :current-page="currPage"
                :page-size="pageSize"
                layout="total, prev, pager, next"
                :total="total"
            />
            <div class="btn-area">
                <el-button @click="handleDialogClose">{{$t(/*取消*/'c.cancel')}}</el-button>
                <el-button @click="handleDialogConfirm" type="primary">{{$t(/*确定*/'c.confirm'),}}</el-button>
            </div>
        </div>
    </el-dialog>
</span>
</template>

<script>
import Core from '../../core'

export default {
    name: "SelectDevice",
    components: {},
    props: {
        btnType: { type: String, default: 'primary', },
        btnText: { type: String },
        plain: { type: Boolean, default: true, },

        taskId: { type: Number, },
        detail: { type: Object, default: () => {return {}} },
        space: { type: [String, Number] },
    },
    data() {
        return {
            loading: false,
            dialogShow: false,

            // 分页配置
			currPage: 1,
			total: 0,
			pageSize: 10,

			searchForm: {
				space: '',
                uid: '',
                user_id: '',
                status: '',
			},
			spaceList: Object.values(Core.Const.DEVICE.SPACE_MAP),
            statusList: Core.Const.DEVICE.STATUS_LIST,
            userList: [],

			tableData: [],
            selectItems: [],
        }
    },
    mounted() {
        this.pageChange(1);
        if (this.$auth('ADMIN')) {
            this.getUserList();
        }
    },
    methods: {
        handleDialogShow() {
            this.searchForm.space = this.space || ''
            if (!this.$auth('ADMIN')) {
                this.searchForm.user_id = Core.Data.getUser().id
            }
            this.pageChange(1)
            this.dialogShow = true
        },
        handleDialogClose() {
            this.dialogShow = false
            for (const key in this.searchForm) {
                this.searchForm[key] = ''
            }
            this.selectItems = [];
        },
        handleDialogConfirm() {
            let selectIds = this.selectItems.map(item => item.device_id)
            this.$emit('submit', selectIds, this.selectItems)
            this.handleDialogClose()
        },


        // 页码变更
		pageChange(val) {
			this.currPage = val;
			this.getTableData();
		},
        // 获取表格数据 - 任务列表
		getTableData() {
            this.loading = true;
            let apiName =  Core.Const.DEVICE.SPACE_MARK.BMS.includes(this.searchForm.space) ? 'Battery' : 'Vehicle'
			console.log('getTableData apiName:', apiName)
			Core.Api[apiName].list({
				page: this.currPage,
                ...this.searchForm
			}).then(res => {
				console.log('getTableData res:', res)
				this.total = res.count;
				this.tableData = res.vehicle_list || res.battery_list;
                this.loading = false;
			}).catch(err => {
                console.log('getTableData err:', err)
                this.loading = false;
            })
		},
        getUserList() {
            Core.Api.User.listAll().then(res => {
                this.userList = res.user_list;
            })
        },

        handleSelectChange(selection) {
            console.log('handleSelectChange selection:', selection)
            this.selectItems = selection
        },
    }

}
</script>

<style scoped lang="scss">
// .SelectDevice {}
</style>